import React from "react"
import VideoPage from "../components/video-page"

const Tentakulum1Page = () => (
  <VideoPage title="TENTAKULUM 1" path="/video/tentakulum-1.{ext}" />
)

export default Tentakulum1Page
